"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addUndoSnapshot_1 = require("./addUndoSnapshot");
var attachDomEvent_1 = require("./attachDomEvent");
var createPasteFragment_1 = require("./createPasteFragment");
var ensureTypeInContainer_1 = require("./ensureTypeInContainer");
var focus_1 = require("./focus");
var getContent_1 = require("./getContent");
var getPendableFormatState_1 = require("./getPendableFormatState");
var getSelectionRange_1 = require("./getSelectionRange");
var getStyleBasedFormatState_1 = require("./getStyleBasedFormatState");
var hasFocus_1 = require("./hasFocus");
var insertNode_1 = require("./insertNode");
var restoreUndoSnapshot_1 = require("./restoreUndoSnapshot");
var selectRange_1 = require("./selectRange");
var setContent_1 = require("./setContent");
var switchShadowEdit_1 = require("./switchShadowEdit");
var transformColor_1 = require("./transformColor");
var triggerEvent_1 = require("./triggerEvent");
/**
 * @internal
 */
exports.coreApiMap = {
    attachDomEvent: attachDomEvent_1.attachDomEvent,
    addUndoSnapshot: addUndoSnapshot_1.addUndoSnapshot,
    createPasteFragment: createPasteFragment_1.createPasteFragment,
    ensureTypeInContainer: ensureTypeInContainer_1.ensureTypeInContainer,
    focus: focus_1.focus,
    getContent: getContent_1.getContent,
    getSelectionRange: getSelectionRange_1.getSelectionRange,
    getStyleBasedFormatState: getStyleBasedFormatState_1.getStyleBasedFormatState,
    getPendableFormatState: getPendableFormatState_1.getPendableFormatState,
    hasFocus: hasFocus_1.hasFocus,
    insertNode: insertNode_1.insertNode,
    restoreUndoSnapshot: restoreUndoSnapshot_1.restoreUndoSnapshot,
    selectRange: selectRange_1.selectRange,
    setContent: setContent_1.setContent,
    switchShadowEdit: switchShadowEdit_1.switchShadowEdit,
    transformColor: transformColor_1.transformColor,
    triggerEvent: triggerEvent_1.triggerEvent,
};
//# sourceMappingURL=coreApiMap.js.map